// extracted by mini-css-extract-plugin
export default {"form":"NovoServico_form__s3WeJ","areaBtn":"NovoServico_areaBtn__Lv6Zx","btn":"NovoServico_btn__SGMWt","btn2":"NovoServico_btn2__OwnQj"};